import React from "react";
import TechnicianHomePage from "../../pages/TechnicianHomePage";

const TechnicianApp = ({ id }) => {
  return (
    <div className="overflow-auto">
      <TechnicianHomePage styles={styles} id={id} />
    </div>
  );
};

export default TechnicianApp;

const styles = {
  componentContainer: {
    border: "none",
    background: "none",
    padding: "0",
  },
  removeBorder: {
    border: "none",
  },
  removePadding: {
    padding: "1.5rem",
    borderRadius: "0.25rem",
  },
};
